// =================================================================================================
// Mona Core API
// The version of the OpenAPI document: https://core.qa1.dev.cmona.de/auto-open-api-spec.yaml 1.9.0
// Contact: https://www.clinomic.biz
//
// NOTE: This class is auto generated at 2026-07-24T13:16:53.216391+03:00[Europe/Kiev]
// by OpenAPI Generator https://openapi-generator.tech
// Do not edit the class manually.
// =================================================================================================

import camelcaseKeys from 'camelcase-keys';
import { instanceToPlain, plainToInstance, Type, Transform } from 'class-transformer';
import snakecaseKeys, { SnakeCaseKeys } from 'snakecase-keys';
import { TransformDate } from '../helpers';
import { PdmsVentilationParameter } from './pdmsVentilationParameter';

export interface PaginatedpdmsVentilationParameterList {
    codes?: Array<string>;
    next?: string | null;
    previous?: string | null;
    results?: Array<PdmsVentilationParameter>;
}
// -----------------------------------------------------------------------------
// Frontend Model
// NOTE: This class is auto generated by OpenAPI Generator
// Do not edit the class manually.
// -----------------------------------------------------------------------------

/**
 * Namespace that holds Frontend models/classes for PaginatedpdmsVentilationParameterList
 */
export namespace PaginatedpdmsVentilationParameterList {
    /**
     * PaginatedpdmsVentilationParameterList Frontend Model with camelCase properties
     * @since 2026-07-24T13:16:53.216391+03:00[Europe/Kiev]
     * @version 1.9.0
     *
     * NOTE: This class is auto generated by OpenAPI Generator
     * Do not edit the class manually.
     */
    export class Model {
        codes?: Array<string>;
        next?: string | null;
        previous?: string | null;
        @Type(() => PdmsVentilationParameter.Model) results?: Array<PdmsVentilationParameter.Model>;

        /** @hideconstructor */
        constructor(obj: Model) {
            Object.assign(this, camelcaseKeys(obj, { deep: true }));
        }
    }
    /**
     * PaginatedpdmsVentilationParameterList DTO
     * Transforms PaginatedpdmsVentilationParameterList model from/to API object
     * @since 2026-07-24T13:16:53.216391+03:00[Europe/Kiev]
     * @version 1.9.0
     *
     * NOTE: This class is auto generated by OpenAPI Generator
     * Do not edit the class manually.
     */
    export class DTO {
        /** Transforms to Frontend PaginatedpdmsVentilationParameterList model */
        static toModel(obj: PaginatedpdmsVentilationParameterList): Model {
            const newObj = camelcaseKeys(obj, { deep: true });
            return plainToInstance(Model, newObj);
        }
        /** Transforms to Backend PaginatedpdmsVentilationParameterList model */
        static toApi(obj: Model): PaginatedpdmsVentilationParameterList {
            const newObj = instanceToPlain(plainToInstance(Model, obj)) as PaginatedpdmsVentilationParameterList;
            return snakecaseKeys(newObj, { deep: true });
        }
    }
}
